import Async from "components/DesignSystem/AsyncComponents/Async";
import Modal from "components/DesignSystem/Modal/Modal";
import { BooksServicesSubscriptionsContent } from "pages/Books/BooksDashboard/BooksServicesSubscriptionsContent";
import { ReactNode } from "react";
import { useGetSubscriptionsQuery } from "store/apis/subscriptions";

export type BooksServicesSubscriptionsModalProps = {
  open: boolean;
  onClose: () => void;
  hideAnualPlan?: boolean;
  description?: ReactNode;
};

export const BooksServicesSubscriptionsModal = ({
  open,
  onClose,
  hideAnualPlan = true,
  description,
}: BooksServicesSubscriptionsModalProps) => {
  const {
    data: subscriptionPlans,
    isLoading,
    isSuccess,
  } = useGetSubscriptionsQuery({});
  return (
    <Modal.Root open={open} onOpenChange={onClose}>
      <Modal.Content size={hideAnualPlan ? "large" : "xl"}>
        <Modal.Header>
          <Modal.Title>Upgrade Your Plan</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <Async.Root
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={false}
            isEmpty={!subscriptionPlans || subscriptionPlans.length === 0}
          >
            <Async.Success>
              {description ? description : null}
              <BooksServicesSubscriptionsContent
                subscriptionPlans={subscriptionPlans}
                hideAnualPlan={hideAnualPlan}
              />
            </Async.Success>
          </Async.Root>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
